import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "confirm-wrapper" }
const _hoisted_2 = { class: "confirm-content" }
const _hoisted_3 = {
  key: 0,
  class: "confirm-content-bts"
}
const _hoisted_4 = {
  key: 0,
  class: "confirm-cover"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "confirm-content-desc",
          innerHTML: _ctx.modalText
        }, null, 8, ["innerHTML"]),
        (_ctx.showCancel)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelClick && _ctx.cancelClick(...args)))
              }, _toDisplayString(_ctx.cancelText), 1),
              _createVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
              }, _toDisplayString(_ctx.submitText), 1)
            ]))
          : (_openBlock(), _createBlock("button", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.btnClick && _ctx.btnClick(...args)))
            }, _toDisplayString(_ctx.btnText), 1))
      ])
    ]),
    (_ctx.showCancel)
      ? (_openBlock(), _createBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}